import { render } from "./LoaderAnimation.vue?vue&type=template&id=33bb29e5&scoped=true&bindings={}"
import script from "./LoaderAnimation.vue?vue&type=script&lang=js"
export * from "./LoaderAnimation.vue?vue&type=script&lang=js"

import "./LoaderAnimation.vue?vue&type=style&index=0&id=33bb29e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33bb29e5"

export default script